// Copyright (c) 2017 Deere & Company

import React, {PropTypes} from 'react';
import Accordion from '../../../../shared/components/accordion';
import Range from '@deere/cps-it.warranty-model-factory/lib/range';
import ReimbursementFacetItem from './reimbursement-facet-item';
import {translate} from '../../../../shared/services/translation-service';

const ReimbursementFacet = props => {

    const accordionBody = props.showReimbursedAmount ?
        (<ReimbursementFacetItem
            buttonLabel={'SHOW_REIMBURSED_PERCENTAGE'}
            label='REIMBURSED_AMOUNT'
            onButtonClick={props.onShowReimbursedPercent}
            onRangeChange={props.onReimbursedAmountChange}
            range={props.reimbursedAmount}
         />) :
        (<ReimbursementFacetItem
            buttonLabel='SHOW_REIMBURSED_AMOUNT'
            label='REIMBURSED_PERCENTAGE'
            onButtonClick={props.onShowReimbursedAmount}
            onRangeChange={props.onReimbursedPercentChange}
            range={props.reimbursedPercent}
         />);

    return (
        <section className='reimbursement-facet'>
            {
                <Accordion
                    accordionId='date-range-picker-accordion'
                    body={accordionBody}
                    isExpanded={props.isExpanded}
                    onClick={props.onClick}
                    title={translate('REIMBURSED')}
                />
            }
        </section>
    );

};

ReimbursementFacet.displayName = 'ReimbursementFacet';
ReimbursementFacet.propTypes = {
    isExpanded: PropTypes.bool.isRequired,
    onClick: PropTypes.func.isRequired,
    onReimbursedAmountChange: PropTypes.func.isRequired,
    onReimbursedPercentChange: PropTypes.func.isRequired,
    onShowReimbursedAmount: PropTypes.func.isRequired,
    onShowReimbursedPercent: PropTypes.func.isRequired,
    reimbursedAmount: PropTypes.instanceOf(Range).isRequired,
    reimbursedPercent: PropTypes.instanceOf(Range).isRequired,
    showReimbursedAmount: PropTypes.bool.isRequired
};

export default ReimbursementFacet;



// WEBPACK FOOTER //
// ./src/tcsm/claim-search/components/facets/reimbursement-facet.js